export default "__VITE_ASSET__EYupW0vA__"